import React from 'react'

import styles from './HeadMark.module.scss'

const HeadMark = ({ text }) => <div className={styles.headMark}>{text}</div>

export default HeadMark
